<template>
  <v-container fluid grid-list-sm style="max-width: 1500px;">
    <manual-config-panel @management-button="onManagementButton"
    />
  </v-container>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import ManualConfigPanel from './components/ManualConfigPanel.vue';

@Component
@Components({ ManualConfigPanel })
export default class ManualConfigManagement extends Vue {
  onManagementButton(route) {
    this.$router.push(route);
  }
}

</script>
